import { ROLES } from "../common/Const";

export const MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.OPERATOR, ROLES.TEACHER];

export const isManageRole = role => MANAGEMENT_ROLES.includes(role);
export const isTeacher = role => role === ROLES.TEACHER;
export const canReadClients = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);
export const canReadBooks = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);
export const canReadPayments = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);
export const canManageClasses = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);
export const canManageClassStudents = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);
export const canManageSettings = role => [ROLES.ADMIN, ROLES.OPERATOR].includes(role);

export function canAccessManagePath(role, pathname) {
  if (!isManageRole(role)) return false;
  if (pathname.startsWith("/manage/settings")) return canManageSettings(role);
  if (pathname.startsWith("/manage/clients") || pathname.startsWith("/manage/client/")) return canReadClients(role);
  if (pathname.startsWith("/manage/books") || pathname.startsWith("/manage/book/")) return canReadBooks(role);
  if (pathname.startsWith("/manage/teachers") || pathname.startsWith("/manage/teacher/")) return !isTeacher(role);
  if (pathname.startsWith("/manage/student/")) return !isTeacher(role);
  if (pathname.startsWith("/manage/reports/client-settlements")) return canReadPayments(role);
  return true;
}
